export default __webpack_public_path__ + "static/media/recuadroCinco.8a053128.png";